import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator, IsEmail } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class RuleValidation extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		const properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;

		const validator = new Validator();
		this.message = '';

		console.log(dynamicProperties);

		if (properties.find(p => p == 'conditions') != null) {

			const r = this.validateConditionGroup("Conditions", true, dynamicProperties['conditions'])

			result = r.result;
			this.message = r.errors;
			
		}
		if (properties.find(p => p == 'branchExecutors') != null) {
			const r = this.validateConditionGroup("Main executors", false, dynamicProperties['branchExecutors'])

			result = result && r.result;
			this.message = this.message.concat(r.errors);
			
		} if (properties.find(p => p == 'alternativeExecutors') != null) {
			const r = this.validateConditionGroup("Alternative executors", true, dynamicProperties['alternativeExecutors'])

			result = result && r.result;
			this.message = this.message.concat(r.errors);

		} 

		return result;
	}

	validateConditionGroup(groupName: string, allowEmpty: boolean, conditions?: { [id: string]: any }[] ): { result: boolean, errors: string } {

		if(!allowEmpty &&(!conditions || conditions.length < 1))
			return { result: false, errors: `You must add at least one definition to ${groupName}. \n` }

		for (var cond of conditions) {

			if (!cond.name || cond.name === "Unsetted")
				return { result: false, errors: `One of the ${groupName} definition is not correctly setted. \n` }

			const values = cond.conditionValues;

			if (values.validate) {
				var validation: {result:boolean, errors: string} = values.validate();

				if (!validation.result)
					return validation;
			}

			if (!!cond.minRetryInterval && !!cond.maxRetryInterval) {
				
				var max = cond.maxRetryInterval;
				var min = cond.minRetryInterval;

				if (max < min) {
					return { result: false, errors: `The ${cond.conditionDefinitionType} executor has an invalid interval configuration.` }
				}

			}
		}

		return { result: true, errors: '' };
	}

	defaultMessage(args: ValidationArguments) {
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/ruleValidator.ts